import type { DesignEditorScrollSnapshot } from '../utils/designEditorScroll';

export type DesignEditorReturnLocation = {
  pathname: string;
  search: string;
  hash: string;
  state?: unknown;
  scroll?: DesignEditorScrollSnapshot;
};

type DesignEditorOrigin = {
  pathname: string;
  search?: string;
  hash?: string;
  state?: unknown;
};

type DesignEditorNavigationState = {
  designEditorReturnTo: DesignEditorReturnLocation;
};

export function buildDesignEditorPath(
  projectId: string,
  sessionId: string | null,
  pageName: string,
): string {
  const sessionSegment = sessionId ? `/${encodeURIComponent(sessionId)}` : '';

  return `/planning/${encodeURIComponent(projectId)}${sessionSegment}/design/pages/${encodeURIComponent(pageName)}?mode=edit`;
}

export function buildDesignEditorNavigationState(
  origin: DesignEditorOrigin,
  scroll?: DesignEditorScrollSnapshot,
): DesignEditorNavigationState {
  return {
    designEditorReturnTo: {
      pathname: origin.pathname,
      search: origin.search ?? '',
      hash: origin.hash ?? '',
      state: origin.state,
      ...(scroll ? { scroll } : {}),
    },
  };
}

export function getDesignEditorReturnLocation(state: unknown): DesignEditorReturnLocation | null {
  if (!state || typeof state !== 'object') return null;
  const candidate = (state as Partial<DesignEditorNavigationState>).designEditorReturnTo;

  if (
    !candidate
    || typeof candidate.pathname !== 'string'
    || !candidate.pathname.startsWith('/')
    || candidate.pathname.startsWith('//')
    || typeof candidate.search !== 'string'
    || typeof candidate.hash !== 'string'
  ) return null;

  return candidate;
}
